define('Components/StopSMSWidget/js/models/StopSMSWidgetInstanceModel',['underscore','backbone','jquery','WidgetInstanceModel','app'],function(_,Backbone,$,WidgetInstanceModel,app){

    function UrlParam(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results ? (results[1] || false) : false;
    }

    var _TRANSLATION_CONTEXT_ = 'StopSMS',
        _LABELS_ = {
            description:'Saisissez votre numéro de téléphone pour ne plus recevoir nos communications par SMS.',
            placeholder:'Téléphone',
            submit:'Désinscription'
        };

    return WidgetInstanceModel.extend({
        name:'StopSMSWidgetModel',
        isVisible:function () {
            var model = this,
                url_key = model.p('url_key'),
                url_val = model.p('url_val'),
                currentUrlParam = UrlParam(url_key),
                isVisible = (currentUrlParam !== false) && (currentUrlParam === url_val);

            return isVisible;
        },
        requestStopSMS:function(phone){
            var model = this,
                campagne = model.p('campagne') || 'default';
            // request stop SMS service
            $.post({
                // hard-coded absolute static URL
                url:'/stop_sms',
                data:{
                    stop_sms_json:1,
                    stop_sms_phone:phone,
                    stop_sms_campagne:campagne
                }
            }).done(function(data){
                if(data.status === 'success'){
                    model.trigger('responseStopSMS',data.message);
                }
            }).fail(function(){
                // Todo
                app.alert();
            })
        },
        label:function(id){
            return app.t(_LABELS_[id],_TRANSLATION_CONTEXT_);
        },
        getPhone:function(){
            return app.getCustomer().getPhone();
        },
        bgColor:function(){
            var inlineStyle = '',
                bg_color = this.p('bg_color') || 'transparent';
            inlineStyle += 'background-color:'+bg_color;
            return inlineStyle;
        },
    })
});
